import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { SHARED_ENVIRONMENT, SharedEnvironment } from '@sd-portal/shared/environment';
import { Observable } from 'rxjs';

@Injectable()
export class SdApiHttpInterceptor implements HttpInterceptor {
  private readonly profileTargetPrefix = '/sdapi/profile/';
  private readonly preFlightTargetPrefix = '/sdapi/pre-flight/';
  private readonly postFlightTargetPrefix = '/sdapi/post-flight/';
  private readonly searchTargetPrefix = '/sdapi/search/';

  constructor(@Inject(SHARED_ENVIRONMENT) private readonly environment: SharedEnvironment) {}

  intercept(
    req: HttpRequest<any>, // eslint-disable-line @typescript-eslint/no-explicit-any
    next: HttpHandler
  ): Observable<
    HttpEvent<any> // eslint-disable-line @typescript-eslint/no-explicit-any
  > {
    let newReq = req;

    if (req.url.startsWith(this.profileTargetPrefix)) {
      const realApiPath = this.buildRealApiPath(
        this.environment.apiroute.profile,
        this.profileTargetPrefix,
        req.url
      );
      newReq = req.clone({ url: realApiPath });
    } else if (req.url.startsWith(this.preFlightTargetPrefix)) {
      const realApiPath = this.buildRealApiPath(
        this.environment.apiroute.preFlight,
        this.preFlightTargetPrefix,
        req.url
      );
      newReq = req.clone({ url: realApiPath });
    } else if (req.url.startsWith(this.postFlightTargetPrefix)) {
      const realApiPath = this.buildRealApiPath(
        this.environment.apiroute.postFlight,
        this.postFlightTargetPrefix,
        req.url
      );
      newReq = req.clone({ url: realApiPath });
    } else if (req.url.startsWith(this.searchTargetPrefix)) {
      const realApiPath = this.buildRealApiPath(
        this.environment.apiroute.search,
        this.searchTargetPrefix,
        req.url
      );
      newReq = req.clone({ url: realApiPath });
    }

    return next.handle(newReq);
  }

  private buildRealApiPath(apiRoute: string, targetPrefix: string, magicApiPath: string): string {
    // No trailing slash
    const trimmedApiRoute = apiRoute.replace(/\/$/, '');
    // No leading slash
    const trimmedApiPath = magicApiPath.substring(targetPrefix.length).replace(/^\//, '');
    return `${trimmedApiRoute}/${trimmedApiPath}`;
  }
}
